





















































































































// import {addEmployee,queryEmployeeById,updateEmployee,ResetEmployee} from '@/api/employee'
// import { queryClienteleById, addClientele, updateClientele } from '@/api/clientele'
import router from '@/router';
// import {addStu, getStuById, updateStu} from '@/api/student'
import { getClienteleStuNames, getCurrentReceipt, updateReceipt } from '@/api/receipts_consultant'
const choiceOptions = ['化学', '生物', '地理', '政治'];
export default {
  data() {
    return {
      isDingJin: false,
      year: '',

      optType: '',//当前操作的类型，新增或者修改
      rechoice: choiceOptions, //再选科目
      isUpdate: false,
      loading: false,
      stuNameOptions: [],
      ruleForm: {

        year: '', // 年份
        stuName: '', // 学生姓名
        amount: '', // 已缴费用
        total: '', // 总金额
        chargeDate: '', // 缴费日期
        chargeDeadlineDate: '', //缴费截止日期
        bz: '', // 备注信息

        // id: '',
        // stuNumber: null,
        //
        // majorCategory: null,
        // majorSubCategory: null,
      },
      rules: {
        year: [
          { required: true, message: '请选择年份', trigger: 'blur' }
        ],
        stuName: [
            { required: true, message: '请输入学生姓名', trigger: 'blur' }
        ],

        amount: [
          { required: true, message: '请输入已缴费用', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!/^[0-9]+(\\.[0-9]{1,2})?$/.test(value)) {
                callback(new Error("请输入合法的数值（可保留两位小数）"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        chargeDate: [
          { type: 'date', required: true, message: '请选择缴费日期', trigger: 'blur' }
        ],
        total: [
          { required: true, message: '请输入总费用', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!/^[0-9]+(\\.[0-9]{1,2})?$/.test(value)) {
                callback(new Error("请输入合法的数值（可保留两位小数）"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
          // { type: 'number', message: '请输入数值'}
        ],
        chargeDeadlineDate: [
          { type: 'date', required: true, message: '请选择补尾款截止日期', trigger: 'blur' }
        ],

      }
    }
  },
  watch: {
    // 当后端返回的年份发生变化时，将年份转换为日期对象
    "ruleForm.year": {
      immediate: true,
      handler(newYear) {
        if (newYear) {
          this.year = new Date(newYear, 0, 1); // 转换为日期对象
        }
      }
    }
  },
  created() {
    // 获取客单学生列表
    this.getStuNameList()
    this.getCurrentReceipt()
    // this.getBz()
    // /*
    //获取路由参数（id），如果有则为修改操作，否则为新增操作
    this.optType = this.$route.query.id ? 'update' : 'add'

     /*
    if(this.optType === 'update') {
      this.loading = true
      this.ruleForm.id = this.$route.query.id
      //修改操作，需要根据id查询员工信息用于页面回显

      getStuById(this.$route.query.id).then(res => {
        if(res.data.code === 1){
          this.ruleForm = res.data.data
          console.log(this.ruleForm)
        }
      })

      //
      // this.loading = false
      this.isUpdate = true
    } */

     // */
  },
  methods: {

    getCurrentReceipt(){
      const params = {
        receiptId: this.$route.query.receiptId
      }
      getCurrentReceipt(params).then(res => {
        if(res.data.code === 1){
          // alert(res.data.data.year)
          const tmp_year = new Date(res.data.data.year, 0, 1)
          // alert(this.ruleForm.year)
          this.ruleForm = res.data.data
          // this.ruleForm.year=tmp_year

          // alert(this.ruleForm.year)

        }else{
          this.$message.error("收据信息获取失败！请返回重新进入。")
        }
      })

    },

    // 获取客单学生名字列表
    getStuNameList(){
      const params = {consultantId: this.$route.query.consultantId}
      getClienteleStuNames(params).then(res => {
        if(res.data.code === 1){
          this.stuNameOptions = res.data.data
        }
      })
    },
    //----------------------------

    submitForm(formName,isContinue) {
      // alert("submit")
      // alert()
      console.log(this.$refs[formName])
      this.$refs[formName].validate((valid) => {
        // alert("validate")
        if (valid) {
          // alert("valid")
          const params = {
            id: this.$route.query.receiptId,
            year: this.ruleForm.year, //年份
            stuName: this.ruleForm.stuName, // 学生姓名
            amount: this.ruleForm.amount, // 已缴费用
            total: this.ruleForm.total, // 总金额
            chargeDate: this.ruleForm.chargeDate, // 缴费日期
            chargeDeadlineDate: this.ruleForm.chargeDeadlineDate, //缴费截止日期
            bz: this.ruleForm.bz, // 备注信息
          }
          updateReceipt(this.ruleForm).then((res) => {
            if (res.data.code === 1) {
              this.$message.success('收据添加成功！')
              if (isContinue) {
                this.ruleForm = {

                  year: '', // 年份
                  stuName: '', // 学生姓名
                  amount: '', // 已缴费用
                  total: 0, // 总金额
                  chargeDate: '', // 缴费日期
                  chargeDeadlineDate: '', //缴费截止日期
                  bz: '', // 备注信息
                }
              } else {
                // this.$router.push('/receipts')
                this.$router.go(-1)
              }

            } else {
              this.$message.error(res.data.msg)
            }
          })

        }else{
          this.$message.error("表单信息有误，请检查表单后重新提交！")
        }
      })

    },
    handleYearChange(value) {
      // 只提取年份部分
      this.ruleForm.year = value ? new Date(value).getFullYear() : "";
      // console.log(value)
      // console.log(this.ruleForm.year)
    },
    handleFormateDate(date){
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}年${month}月${day}日`;
    },
    getBz(){
      this.$refs['ruleForm'].validate(valid => {
        if(valid){
          let rest = (this.ruleForm.total-this.ruleForm.amount) > 0 ? (this.ruleForm.total-this.ruleForm.amount) : 0;
          let bz = this.handleFormateDate(this.ruleForm.chargeDeadlineDate) + "之前补尾款" + rest + "元或退费，双向选择。含4+1生涯规划。";
          this.ruleForm.bz = bz;
        }
        // alert(valid)

      })

    },
    fillTotal(){
      if(!this.isDingJin){
        this.ruleForm.total = ''
      }else {
        this.ruleForm.total = 0
      }
    },


  }
}
